import { UserRole } from "configs/constants";
import { withPermission } from "hocs/withPermission";
import React from "react";
import { useSelector } from "react-redux";
import withFetchOne from "../../../../hocs/withFetchOne";
import AdminForm from "../components/form/AdminForm";
import AdminClientHeader from "../components/header/AdminClientHeader";
import { doGetUser } from "../store/thunks";
import { selectUser } from "../store/userSlice";
import "./AdminUserCreateClient.scss";

const AdminEditUserAdmin = () => {
  const breadCrumbs = [
    { text: "USERS" },
    { url: "/admin/users/admins", text: "ADMINS" },
    { text: "EDIT" }
  ];
  const userClient = useSelector(selectUser);
  return (
    <div className="AdminEditUserClient admin-create-update-client">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Edit Admin User</h2>
        <AdminForm clientUser={userClient} />
      </div>
    </div>
  );
};
export default withPermission(
  withFetchOne(AdminEditUserAdmin, {
    fetchData: doGetUser
  }),
  [UserRole.ADMIN]
);
